import { combineReducers } from 'redux'

import layoutTemplateFilters from './layoutTemplateFilters'
import micrositeFilters from './micrositeFilters'
import pageBuilderSettings from './pageBuilderSettings'
import templatePage from './templatePage'
import templatePageFilters from './templatePageFilters'
import templatePagePartialFilters from './templatePagePartialFilters'
import templateTasks from './templateTasks'

export default combineReducers({
  layoutTemplateFilters,
  micrositeFilters,
  pageBuilderSettings,
  templatePage,
  templatePageFilters,
  templatePagePartialFilters,
  templateTasks,
})
